import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Settings, LogOut, Users } from 'lucide-react';
import useAuthStore from '../store/authStore';
import { isOrgAdmin } from '../utils/permissions';

export default function UserMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const initials = user?.name
    ? user.name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2)
    : '?';

  const isAdmin = isOrgAdmin(user);

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  const handleLogout = () => {
    setOpen(false);
    logout();
    navigate('/login');
  };

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-8 h-8 rounded-full bg-accent text-white flex items-center justify-center text-xs font-semibold hover:ring-2 hover:ring-accent/40 transition-all"
        title={user?.name || 'Conta'}
      >
        {user?.avatar_url ? (
          <img src={user.avatar_url} alt={user.name} className="w-full h-full rounded-full object-cover" />
        ) : (
          initials
        )}
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-2 w-64 bg-card border border-border rounded-xl shadow-2xl overflow-hidden z-50">
          <div className="px-4 py-3 border-b border-border/50">
            <div className="text-sm font-semibold text-text-primary truncate">{user?.name}</div>
            <div className="text-xs text-text-secondary truncate">{user?.email}</div>
            {user?.role_name && (
              <div className="mt-1 inline-block text-[10px] px-1.5 py-0.5 rounded bg-accent/15 text-accent font-medium">
                {user.role_name}
              </div>
            )}
          </div>
          <div className="py-1">
            <button
              onClick={() => go('/settings/profile')}
              className="w-full flex items-center gap-3 px-4 py-2 text-sm text-text-primary hover:bg-white/5 transition-colors"
            >
              <User className="w-4 h-4" />
              Meu perfil
            </button>
            {isAdmin && (
              <button
                onClick={() => go('/settings/users')}
                className="w-full flex items-center gap-3 px-4 py-2 text-sm text-text-primary hover:bg-white/5 transition-colors"
              >
                <Users className="w-4 h-4" />
                Administração
              </button>
            )}
            <button
              onClick={() => go('/settings')}
              className="w-full flex items-center gap-3 px-4 py-2 text-sm text-text-primary hover:bg-white/5 transition-colors"
            >
              <Settings className="w-4 h-4" />
              Configurações
            </button>
          </div>
          <div className="border-t border-border/50 py-1">
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-2 text-sm text-danger hover:bg-danger/10 transition-colors"
            >
              <LogOut className="w-4 h-4" />
              Sair
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
